import * as React from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import styled from 'styled-components';
import { ContentSpacing } from '@estee/elc-base-theme';

import { classes } from '../../utils/Classes';
import { VtoShadeItem } from '../common/VtoShadeItem';
import { VTO_CUSTOM_PAIR_SHADE_PICKER } from '../../constants/DataTestIdAttributes';
import { IShade, IVtoFoundationPairShadeLabels } from '../../interfaces/IVto';

export interface IVtoPairShadePicker {
    vtoFoundationPairText: IVtoFoundationPairShadeLabels;
    onPairShadeSelect(shadeName: string): void;
    selectedPairShade?: IShade;
    selectedPairShades: { [key: string]: IShade };
}

const CustomPairShadePicker = styled.div`
    margin-top: ${ContentSpacing.space6};
    display: flex;
    justify-content: space-around;
`;

const customShadePickerClassNames = classes('vto-custom-shade-picker');

@observer
export class VtoPairShadePicker extends React.Component<IVtoPairShadePicker> {
    @computed
    public get customShades(): JSX.Element[] {
        const {
            vtoFoundationPairText,
            onPairShadeSelect,
            selectedPairShade,
            selectedPairShades
        } = this.props;

        return Object.entries(selectedPairShades).map(([shadeType, shade]) => {
            const handleShadeClick = () => {
                if (shade.name && onPairShadeSelect) {
                    onPairShadeSelect(shade.name);
                }
            };
            const perfectShadeLabel =
                vtoFoundationPairText[shadeType as keyof IVtoFoundationPairShadeLabels] || '';
            const _shade = { ...shade, perfectShadeLabel };

            return (
                <VtoShadeItem
                    key={`${shade.hexVal}-shade`}
                    shade={_shade}
                    selectedShade={selectedPairShade}
                    isPerfectShadeEnabled
                    onClick={handleShadeClick}
                />
            );
        });
    }

    public render() {
        return (
            <CustomPairShadePicker
                data-test-id={VTO_CUSTOM_PAIR_SHADE_PICKER}
                className={customShadePickerClassNames}
            >
                {this.customShades}
            </CustomPairShadePicker>
        );
    }
}
